// @ts-nocheck
import React from "react";
import Navclose from "../Svgs/Navclose.svg";
import NavContent from "./NavContent";

const MobileNavigation = ({ showMenu, setShowMenu, currentThread, threadDispatch }) => {
  if (!showMenu) return null;
  
  return (
    <nav className="hidden max-sm:block">
      <div className="navItems">
        <NavContent
          chatLog={currentThread?.messages || []}
          setChatLog={(newMessages) =>
            threadDispatch({
              type: "SET_THREAD_MESSAGES",
              payload: newMessages,
            })
          }
          setShowMenu={setShowMenu}
        />
      </div>
      <div className="navCloseIcon">
        <img src={Navclose} onClick={() => setShowMenu(false)} alt="Close navigation" />
      </div>
    </nav>
  );
};

export default MobileNavigation;